import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { Solicitation } from 'src/app/models/card-solicitation';
import { SolicitationRequest, UpdateSolicitationRequest } from 'src/app/models/request/card-solicitation-request';
import { CardDataResponse, SolicitationResponse } from 'src/app/models/response/card-solicitation-response';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CardSolicitationService } from 'src/app/services/card-solicitation.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';

@Component({
  selector: 'app-cartoes-fisicos-list',
  templateUrl: './cartoes-fisicos-list.component.html',
  styleUrls: ['./cartoes-fisicos-list.component.css']
})
export class CartoesFisicosListComponent implements OnInit {

    private currentUser: Auth;
    public cardsData: CardDataResponse = new CardDataResponse();
    public solicitationRequest: SolicitationRequest;
    public solicitationResponse: SolicitationResponse;
    public solicitations: Solicitation[] =[];
    public offset: number = 0;
    public currentPage: number = 1;
    public showItem = '10';
    public totalSolicitations: number = 0;

    solicitationToCancel: Solicitation;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private alertService: NewAlertService,
        private modalService: NgbModal,
        private authenticationService: AuthenticationService,
        private cardSolicitationService: CardSolicitationService
    ) { }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        // this.getCardsData();
        // this.getSolicitations();
    }

    getCardsData(){
        this.cardSolicitationService.cardsData(this.currentUser.token.assignorGuid).subscribe(
            response => {
                if(response.status == ApiError.Sucesso){
                    this.cardsData = response.result;
                    this.cardsData.activeCards;
                }
            },
            error => {console.log(error)}
        )
    }

    getSolicitations(){
        this.solicitationRequest = new SolicitationRequest(this.currentUser.token.assignorGuid)
        this.cardSolicitationService.solicitations(this.solicitationRequest, this.offset, parseInt(this.showItem)).subscribe(
            response => {
                if(response.status == ApiError.Sucesso){
                    this.solicitationResponse = response.result;
                    this.totalSolicitations = this.solicitationResponse.totalSolicitations;
                    this.solicitations = this.solicitationResponse.solicitations;
                }
            },
            error => {console.log(error)}
        )
    }

    details(solicitation: Solicitation) {
        sessionStorage.setItem('currentPageC',this.currentPage.toString());
        this.router.navigate([`pedidodetalhes/${solicitation.solicitationId}`], { relativeTo: this.route.parent });
    }

    showCancel(content: any, solicitation: Solicitation) {
        this.solicitationToCancel = solicitation;
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    cancel(solicitation: Solicitation) {
        let updateSolicitationRequest = new UpdateSolicitationRequest();
        updateSolicitationRequest.assignorGuid = this.currentUser.token.assignorGuid;
        updateSolicitationRequest.managerGuid = this.currentUser.token.userReferenceId;
        updateSolicitationRequest.solicitationId = solicitation.solicitationId;
        updateSolicitationRequest.reason = "Pedido Cancelado via Portal";
        this.cardSolicitationService.updateSolicitation(updateSolicitationRequest).subscribe(
            response => {
            if (response.status === ApiError.Sucesso) {
                this.alertService.success("Pedido cancelado com sucesso!");
                // this.getSolicitations();
                // this.getCardsData();
            } else {
                this.alertService.error(response.message);
            }
            }, error => { this.alertService.error(error); }
        );
    }

    //#region Paginacao
    changePage(event) {
        this.currentPage = event;
        this.offset = (this.currentPage - 1) * + parseInt(this.showItem);
        // this.getSolicitations();
    }

    showItemChanged(event){
      this.showItem = event;
      this.currentPage = this.currentPage;
      this.offset = this.offset + (this.currentPage - 1) * + parseInt(this.showItem);
    //   this.getSolicitations();
    }
    //#endregion

    navigateToCartoesPedido(){
        this.router.navigate(['portal/cartoes/novopedido']);
    }
}
